import { axios } from '../../../axios';

const getPropertyByIdApi = (id) => {
  return axios.get(`/properties/${id}`)
}

export { getPropertyByIdApi }